import { SvgIcon } from '@mui/material'

export default function decline(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <rect width="20" height="20" rx="10" fill="#FFDEDE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49614 5.38284C4.16842 5.62448 4.1033 6.09665 4.3507 6.43745L7.58334 10.8906C7.70765 11.0618 7.89481 11.1749 8.10004 11.2028C8.30528 11.2307 8.51012 11.1708 8.66558 11.0376L10.3624 9.58327L12.6554 12.8586C12.897 13.2036 13.362 13.2924 13.694 13.0568C14.0261 12.8212 14.0994 12.3506 13.8579 12.0055L11.0869 8.04753C10.9642 7.87223 10.7762 7.75528 10.5689 7.72523C10.3616 7.69517 10.154 7.75479 9.99683 7.88951L8.28924 9.35308L5.53748 5.56239C5.29009 5.22159 4.82386 5.1412 4.49614 5.38284Z"
        fill="#E74F4F"
      />
      <path
        d="M15.8039 10.8284C15.827 10.6383 15.5955 10.5276 15.462 10.6648L13.4003 12.7844L10.8855 13.8278C10.7082 13.9014 10.7263 14.1581 10.9121 14.2062L14.7041 15.1862C14.9968 15.2619 15.2891 15.0625 15.3256 14.7625L15.8039 10.8284Z"
        fill="#E74F4F"
      />
    </SvgIcon>
  )
}
